import React, { useEffect } from 'react';
import useQueryStringParams from 'hooks/useQueryStringParams';
import EntryForm from 'components/organisms/EntryForm/EntryForm';
import classes from './SignUp.module.scss';
import clsx from 'clsx';
import OinqSuccess from 'components/assets/oinq/oinq_signup_success_shadow.svg';

export interface Props {
  disableRedirectAfterLogin?: boolean;
}

const SignUp: React.FC<Props> = () => {
  const params = useQueryStringParams();

  return (
    <main className={clsx(classes.root, 'fadedPageBg')}>
      <div className={classes.formWidthContainer}>
        <EntryForm
          className={classes.formContainer}
          title="Create your account"
          subtitle="It's quick and easy"
        />
        <OinqSuccess className={classes.oinq} />
      </div>
    </main>
  );
};
export default SignUp;
